import React from "react";
import { TrendingUp, TrendingDown, AlertCircle } from "lucide-react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const StatsCard = ({
  title,
  icon: Icon,
  value,
  prefix,
  suffix,
  subtitle,
  trend,
  variant = "default",
  showChart = false,
  data,
  formatValue,
}) => {
  const getTrendColor = (value) => {
    if (!value) return "";
    return value > 0 ? "stats-card__trend--up" : "stats-card__trend--down";
  };

  const getTrendIcon = (value) => {
    if (!value) return null;
    return value > 0 ? (
      <TrendingUp className="h-3 w-3" />
    ) : (
      <TrendingDown className="h-3 w-3" />
    );
  };

  return (
    <div className={`stats-card stats-card--${variant} relative `}>
      {(variant === 'warning' || variant === 'danger') && (
        <div className="absolute top-2 right-2">
          <AlertCircle className="h-5 w-5 text-yellow-400" />
        </div>
      )}
      <div className="stats-card__chart">
        {showChart && (
          <PieChartCard data={data} height={150} formatValue={formatValue} />
        )}
      </div>
      <div className="stats-card__content">
        <div className="stats-card__header">
          <div className="stats-card__title-group">
            {Icon && <Icon className="stats-card__icon" />}
            <span className="stats-card__title">{title}</span>
          </div>
        </div>

        <div className="stats-card__value-section">
          <div className="stats-card__value-container">
            <div className="stats-card__main-value">
              {prefix && <span className="stats-card__prefix">{prefix}</span>}
              <span className="stats-card__value">{value}</span>
              {suffix && <span className="stats-card__suffix">{suffix}</span>}
            </div>

            {trend !== undefined && (
              <div className={`stats-card__trend ${getTrendColor(trend)}`}>
                {getTrendIcon(trend)}
                <span className="stats-card__trend-value">
                  {Math.abs(trend)}%
                </span>
              </div>
            )}
          </div>

          {subtitle && (
            <div className="stats-card__subtitle-container">
              <span className="stats-card__subtitle">{subtitle}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export function PieChartCard({ data = [], height = 70, formatValue }) {
  return (
    <div className="min-w-[70px] pr-2 border-r border-gray-300 mr-4">
      <div style={{ height: 100 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius="60%"
              outerRadius="100%"
              paddingAngle={4}
              dataKey="value"
              nameKey="label"
              minAngle={0}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              content={({ active, payload }) => {
                if (active && payload && payload.length) {
                  const data = payload[0].payload;
                  return (
                    <div className="bg-white p-2 border border-gray-300 rounded-lg shadow-sm">
                      <p className="text-xs font-medium text-gray-900">
                        {data.label}
                      </p>
                      <p className="text-xs text-gray-600">
                        {formatValue ? formatValue(data.value) : data.value}
                      </p>
                    </div>
                  );
                }
                return null;
              }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default StatsCard;
